// Types
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

import type { SocialProfileType } from '@/types/socialProfileType';

// Lib
import { PERMISSIONS } from '@/lib/permissions/socialPermissions';

// Routes
import { SOCIAL_PROFILE_PERMISSIONS } from '@/routes/apiEndpoints';

export type SocialProfilePermissionsType = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

const useSocialProfilePermissions = (
    activeSPID: SocialProfileType['id'],
    options?: SWRConfiguration<SocialProfilePermissionsType[], Error>
) => {
    const {
        data,
        mutate: mutatePermissions,
        error: permissionsError
    } = useSWR<SocialProfilePermissionsType[], Error>(
        activeSPID
            ? injectEndpointUrlParams(SOCIAL_PROFILE_PERMISSIONS, {
                  SPID: activeSPID
              })
            : null,
        (url) => get(url).then((res) => res.data.permissions),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        permissions: data ?? [],
        mutatePermissions,
        permissionsError,
        isLoading: !data && !permissionsError
    };
};
export default useSocialProfilePermissions;
